import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enTranslations from './locales/en/common.json';
import jaTranslations from './locales/ja/common.json';

const resources = {
    en: {
        common: enTranslations,
    },
    ja: {
        common: jaTranslations,
    },
};

// Function to get stored language or detect from browser
const getStoredLanguage = () => {
    const stored = localStorage.getItem('language');
    if (stored && resources[stored]) {
        return stored;
    }
    
    // Fallback to browser language detection
    const browserLang = navigator.language.substring(0, 2);
    return resources[browserLang] ? browserLang : 'en';
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: getStoredLanguage(),
        fallbackLng: 'en',
        defaultNS: 'common',

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },

        // Add debug mode for development
        debug: process.env.NODE_ENV === 'development',
    });

// Save language to localStorage whenever it changes
i18n.on('languageChanged', (lng) => {
    localStorage.setItem('language', lng);
});

export default i18n; 